// Bootstrap 5 has no `min-w-0` utility, but a flex item defaults to `min-width: auto` — the
// recipient address span's `text-truncate` has nothing to clip against a long address until this
// floor is cleared (webui-styling-style-guide.md §1 "text-truncate in a flex row").
.flexTruncate {
  min-width: 0;
}
